































































import { GitRepositoryDetailHeaderTitle } from '@/@types/LibraryComponent';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class RepositoryDetailHeader extends Vue {
  @Prop({ required: true, default: 0 })
  private filesCount!: number;
  @Prop({ required: true, default: 0 })
  private branchesCount!: number;
  @Prop({ required: true, default: 0 })
  private commitLogsCount!: number;
  private selectMenu: number = 0;
  private changeSelected(index: number) {
    this.selectMenu = index;
    this.$emit('selectMenu', this.selectMenu);
  }
  private gitMenus: Array<{
    name: string;
    icon: string;
    url: string;
  }> = [
    {
      name: GitRepositoryDetailHeaderTitle.tableHeader.codes,
      icon: 'code-tags',
      url: 'test',
    },
    {
      name: GitRepositoryDetailHeaderTitle.tableHeader.branches,
      icon: 'source-branch',
      url: 'test',
    },
    {
      name: GitRepositoryDetailHeaderTitle.tableHeader.commits,
      icon: 'source-commit',
      url: 'test',
    },
    {
      name: GitRepositoryDetailHeaderTitle.tableHeader.network,
      icon: 'graph',
      url: 'test',
    },
    {
      name: GitRepositoryDetailHeaderTitle.tableHeader.pullRequests,
      icon: 'source-pull',
      url: 'test',
    },
  ];

  private getValue(title: string) {
    if (title === GitRepositoryDetailHeaderTitle.tableHeader.codes) {
      return this.filesCount;
    } else if (title === GitRepositoryDetailHeaderTitle.tableHeader.branches) {
      return this.branchesCount;
    } else if (title === GitRepositoryDetailHeaderTitle.tableHeader.commits) {
      return this.commitLogsCount;
    } else return 0;
  }
}
